import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-3" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "table table-sm table-striped table-bordered table-hover" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "row mb-2" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "text-danger fw-bold" }

import { onMounted, reactive, watch } from "vue";

//servicos
import * as service from "@/services/empresasService";
import {fdata, fdataUS} from "@/utils/funcoes";

//componentes
import TrataTecla from "@/components/TrataTecla/Index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import AutoCompleteClientes from "@/components/AutoCompletes/AutoCompleteClientes.vue";

interface IProps {
  EmpresaId?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EmpresasFuncionarios',
  props: {
    EmpresaId: {}
  },
  setup(__props: any) {


//vue
var props = __props;

  var controle = reactive({
    empresaId: props.EmpresaId as number | null | undefined,
    itens: [] as service.FuncionarioDto[],
    model: {
      empresaId: props.EmpresaId
    } as service.EmpresaFuncDto,
    janela: false,
    janPergunta:false,
    erro: "",
    status: ""
  })

  onMounted(() => {
   
    buscarItems();

  });

  watch(() => props.EmpresaId, (newValue) => {
    controle.empresaId = newValue;
    controle.model.empresaId = newValue ?? 0;
    buscarItems();
  });

  async function buscarItems() {

      if (!props.EmpresaId) {
        controle.itens = [];
        return;
      }

      console.log("buscando items empresaId: ", controle.empresaId);

      controle.status = "Buscando items...";
      controle.erro = "";
      service.obterFuncionarios(controle.empresaId as number)
      .then((r) => {
        controle.itens = r;
        controle.status = "";
      })
      .catch((error) => {
        controle.erro = `Erro ao buscar items: ${error}`;
        controle.status = "";
      });
  }
      
  async function adicionar() {

      controle.status = "Salvando item...";
      controle.erro = "";

      service.adicionarFuncionario(controle.model)
      .then(() => {
        controle.status = "";
        controle.model = {
          empresaId: controle.model.empresaId,
          clienteId: 0,
        } as service.EmpresaFuncDto;
        buscarItems();
        controle.janela = false;
      })
      .catch((error) => {
        controle.erro = `Erro ao salvar item: ${error}`;
        controle.status = "";
      });
  }

  function excluir(item: service.EmpresaFuncDto) {
    controle.model = item;
    controle.janPergunta = true;
  }

  function excluirConfirma()
  {
    console.log("excluir: ", controle.model);
    controle.janPergunta = false;
    controle.status = "Excluindo item...";
    controle.erro = "";

    service.excluirFuncionario(controle.model)
    .then(() => {
      controle.status = "";
      controle.model = {
        empresaId: controle.model.empresaId,
        clienteId: 0,
      } as service.EmpresaFuncDto;
      buscarItems();
    })
    .catch((error) => {
      controle.erro = `Erro ao excluir item: ${error}`;
      controle.status = "";
    });
  }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", { class: "card-title" }, "Funcionários")
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(AutoCompleteClientes, {
                  modelValue: _unref(controle).model.clienteId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).model.clienteId) = $event)),
                  placeholder: 'Digite o nome ou CPF',
                  onSelected: _cache[1] || (_cache[1] = (item) => { _unref(controle).model.clienteId = item.clienteId; })
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("a", {
                  class: "btn btn-sm btn-primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (adicionar()))
                }, "Adicionar")
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                  _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Plano"),
                      _createElementVNode("th", null, "Nome"),
                      _createElementVNode("th", null, "Nascimento"),
                      _createElementVNode("th", null, "CPF"),
                      _createElementVNode("th", null, "Celular"),
                      _createElementVNode("th", null, "Ações")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(item.planoNome), 1),
                        _createElementVNode("td", null, _toDisplayString(item.nome), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(fdata)(item.dataNascimento)), 1),
                        _createElementVNode("td", null, _toDisplayString(item.cpf), 1),
                        _createElementVNode("td", null, _toDisplayString(item.celular), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-danger",
                            title: "Excluir registro",
                            onClick: ($event: any) => (excluir({  empresaId: _unref(controle).empresaId as number, clienteId: item.clienteId }))
                          }, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                          ]))], 8, _hoisted_9)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, "Registros: " + _toDisplayString(_unref(controle).itens.length), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(controle).status), 1),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(controle).erro), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(MsgBox, {
      id: 'janPergunta2',
      class: "modal-md",
      "data-bs-backdrop": "static",
      exibir: _unref(controle).janPergunta,
      titulo: 'Atenção',
      onOnFechou: _cache[3] || (_cache[3] = ($event: any) => (_unref(controle).janPergunta = false)),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[4] || (_cache[4] = ($event: any) => (excluirConfirma()))
    }, {
      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
        _createElementVNode("div", { class: "row mb-2" }, [
          _createElementVNode("div", { class: "col-md-12 fs-5 fw-bold text-center" }, " Deseja excluir este registro ? ")
        ], -1)
      ]))]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})